import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'

export interface IssueAnalyticsData {
    top_tenants: IssueAnalyticsItem[]
    top_locations: IssueAnalyticsItem[]
    top_inventories: IssueAnalyticsItem[]
    top_services: IssueAnalyticsItem[]
    vendor_data: {
        [key: string]: {
            assigned_count: number
            completed_count: number
        }
    }
    assigned_daily: DailyCount[]
    completed_daily: DailyCount[]
}

export interface IssueAnalyticsItem {
    name: string
    total_count: number
    date_data: DailyCount[]
}

export interface DailyCount {
    date: string
    count: number
}

export interface IssueAnalyticsLoadingState {
    mainPage: boolean
    detailPage: boolean
}

export const useIssueAnalytics = () => {
    const [
        issueAnalytics,
        setIssueAnalytics,
    ] = useState<IssueAnalyticsData | null>(null)
    const [
        loadingState,
        setLoadingState,
    ] = useState<IssueAnalyticsLoadingState>({
        mainPage: false,
        detailPage: false,
    })

    const getIssueAnalytics = async (statusStr: string) => {
        try {
            setLoadingState((prev) => ({ ...prev, mainPage: true }))
            const response = await axiosInstance.get(
                'lease/get_issues_analytics/',
                {
                    params: {
                        statuses: statusStr,
                    },
                },
            )
            const data: IssueAnalyticsData = response.data
            setIssueAnalytics(data)
            setLoadingState((prev) => ({ ...prev, mainPage: false }))
            return data
        } catch (e: any) {
            toast.error('Failed to fetch issue analytics')
            setLoadingState((prev) => ({ ...prev, mainPage: false }))
            return Promise.reject(e)
        }
    }

    return {
        issueAnalytics,
        loadingState,
        getIssueAnalytics,
        setIssueAnalytics,
    }
}
